<template>
  <b-card title="Section">
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Rechercher</label>
          <b-form-input v-model="searchTerm" placeholder="Recherche" type="text" class="d-inline-block mr-1" />
          <b-button variant="primary" @click="openAddModal">
            <span class="text-nowrap">Ajouter</span>
          </b-button>
        </div>
      </b-form-group>
    </div>

    <div>
      <table id="sortableTable" class="table table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Partie</th>
            <th>Titre</th>
            <th>Description</th>
            <th>Statut</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(section, index) in sections" :key="section.idPublic">
            <td>{{ index + 1 }}</td>
            <td>{{ section.party }}</td>
            <td>{{ section.title }}</td>
            <td>{{ section.description }}</td>
            <td>
              <b-badge :variant="statusVariant(section.active)">
                {{ section.active ? "Activé" : "Désactivé" }}
              </b-badge>
            </td>


            <td>
              <b-col class="col-fixed col-actions d-flex justify-content-end align-items-center">
                <feather-icon  v-if="section.active" :id="`invoice-row-${section.idPublic}-preview-icon`" icon="EyeIcon" size="16" class="mx-1"
                  @click="$router.push({ name: 'content-section', params: { id: section.idPublic } })" />
                <b-tooltip title="Detail" :target="`invoice-row-${section.idPublic}-preview-icon`" />

                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template v-slot:button-content>
                    <more-vertical-icon size="16" class="text-body align-middle mr-25" />
                  </template>
                  <b-dropdown-item   @click="openEditModal(section)">
                    <edit-2-icon class="mr-50" />
                    <span>Modifier</span>
                  </b-dropdown-item>

                  <b-dropdown-item v-if="section.isUsed" @click="deactivateSectionHandler(section.idPublic, !section.active)">
                    <ToggleLeftIcon class="mr-50" />
                    <span>{{ section.active ? "Désactiver" : "Activer" }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item v-else @click="confirmDeleteSection(section.idPublic)">
                    <trash-icon class="mr-50" />
                    <span>Supprimer</span>
                  </b-dropdown-item>



                  <!-- <b-dropdown-item @click="()">
                    <trash-icon class="mr-50" />
                    <span>Supprimer</span>
                  </b-dropdown-item> -->
                </b-dropdown>
              </b-col>
            </td>
          </tr>
        </tbody>
      </table>

      <b-modal v-model="isModalActive" :title="modalTitle" @hide="resetModal" cancelTitle="Fermer" centered >
        <b-form @submit.prevent="handleSubmit">
          <!-- <b-form-group label="Partie">
            <b-form-input v-model="currentSection.party" required />
          </b-form-group> -->
          <b-form-group label="Nom de la section">
            <b-form-input v-model="currentSection.title" required />
          </b-form-group>

          <b-form-group label="Description de la section">
            <b-form-textarea v-model="currentSection.description" />
          </b-form-group>

          <b-form-group label="Choix de la réponse">
            <b-form-radio-group v-model="currentSection.responseChoice" :options="options" class="demo-inline-spacing"
              name="radio-inline" />
          </b-form-group>

          <hr class="my-1">

          <b-form-group label="Calcul">
            <b-form-checkbox
              v-model="currentSection.requiredCalcul"
            >
              Requiert un calcul
            </b-form-checkbox>
          </b-form-group>

          <hr class="my-1">

          <b-form-group label="Personne concernée">
            <b-form-checkbox-group v-model="currentSection.categories" :options="categories" value-field="item"
              text-field="name" disabled-field="notEnabled" class="demo-inline-spacing" />
          </b-form-group>

          <hr class="my-1">

          <b-form-group label="Visibilité">

            <b-form-checkbox
                aria-label=""
                class="custom-control custom-control-inline custom-checkbox mt-2"
                v-model="currentSection.visibilityButton"
            >
              Visibilité Bouton
            </b-form-checkbox>

            <b-form-checkbox
                class="custom-control custom-control-inline custom-checkbox mt-2"
                v-model="currentSection.visibilityForm"
            >
              Visibilité dans le formulaire
            </b-form-checkbox>

          </b-form-group>

          <b-form-group label="Temps avant disparition de la section en Heure" class="mt-2">
            <b-form-input v-model="currentSection.visibilityTime" />
          </b-form-group>

          <hr class="my-1">

          <b-button type="submit" variant="primary">
            {{ isEditMode ? 'Modifier' : 'Ajouter' }}
          </b-button>
        </b-form>
      </b-modal>

    </div>
  </b-card>
</template>

<script>
import sortable from 'sortablejs';
import { allSection, saveSection, updateSection, deleteSection, updateSectionOrder,disableSection } from '@/services/SectionService';
import { MoreVerticalIcon, Edit2Icon, TrashIcon,ToggleLeftIcon } from 'vue-feather-icons';
import {
  BFormGroup, BFormInput, BButton, BDropdown, BDropdownItem, BCard, BCol, BTooltip, BForm, BModal,
  BFormTextarea, BFormCheckboxGroup,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

//import Swal from 'sweetalert2';

export default {
  components: {
    BCard,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BModal,
    BCol,
    BTooltip,
    BFormCheckboxGroup,
    BFormTextarea,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    MoreVerticalIcon,
    Edit2Icon,
    TrashIcon,
    ToggleLeftIcon
  },
  data() {
    return {
      sections: [],
      searchTerm: '',
      isModalActive: false,
      isEditMode: false,
      modalTitle: '',
      categories: ['Personne évaluée', 'Supérieur hiérarchique', 'Directeur général'],
      options: ['Standard', 'Tableau'],

      currentSection: {
        idPublic: null,
        party: '',
        title: '',
        responseChoice: '',
        requiredCalcul: false,
        description: '',
        categories:[],
        visibilityButton: false,
        visibilityTime: 0,
        visibilityForm: false,
      },
    };
  },
  methods: {
    showToast(message,color) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: "CheckCircleIcon",
          variant: color,
        },
      });
    },
    errorNotif(text) {
      this.$swal({
        title: 'Erreur!',
        text: text,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    async fetchSections() {
      try {
        this.sections = await allSection();
      } catch (error) {
        console.error('Erreur lors du chargement des sections :', error);
      }
    },
    openAddModal() {
      this.isEditMode = false;
      this.modalTitle = 'Ajouter';
      this.isModalActive = true;
    },
    openEditModal(section) {
      this.isEditMode = true;
      this.modalTitle = 'Modifier';
      this.currentSection = { ...section };
      this.isModalActive = true;
    },
    resetModal() {
      this.currentSection = {
        id: null,
        title: '',
        party: '',
        description: '',
        responseChoice: '',
        requiredCalcul: false,
        visibilityButton: false,
        visibilityTime: 0,
        visibilityForm: false,
      };
    },
    async handleSubmit() {
      try {
        if (this.isEditMode) {
          await updateSection(this.currentSection.idPublic, this.currentSection);
          const index = this.sections.findIndex(sec => sec.idPublic === this.currentSection.idPublic);

          if (index !== -1) {
            this.$set(this.sections, index, this.currentSection);
          }
        } else {
          const newSection = await saveSection(this.currentSection);
          this.sections.push(newSection);
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Section enregistré avec succès',
            icon: 'EditIcon',
            variant: 'success',
          },
        });
        this.isModalActive = false;
      } catch (error) {
        this.errorNotif('Erreur lors de la soumission du formulaire')
      }
    },
    async deactivateSectionHandler(sectionId, active) {
      try {
      const updatedUser = await disableSection(sectionId, {
        active: active,
      });
      const row = this.sections.find((r) => r.id === sectionId);

if (row) Object.assign(row, updatedUser);
        this.showToast(`Section ${active ? 'activé' : 'désactivé'} avec succès.`);
      } catch (error) {
        this.showToast(`Échec de la mise à jour du statut.`,"danger");

        console.error("Error updating data:", error);
      }

    },
    confirmDeleteSection(sectionId) {
      this.$swal({
        title: '<span class="font-weight-bolder"> <u>ObjectivEval</u></span>',
        text: 'Voulez-vous vraiment supprimer cette section?',
        //icon: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Oui, supprimer!',
        cancelButtonText: 'Annuler',
        // confirmButtonAriaLabel: 'Oui, supprimer!',
        // cancelButtonAriaLabel: 'Annuler',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await deleteSection(sectionId);
            this.sections = this.sections.filter(section => section.idPublic !== sectionId);
            // Swal.fire(
            //   'Supprimé!',
            //   'La section a été supprimée.',
            //   'success'
            // );
            this.$swal({
              position: 'top-end',
              icon: 'success',
              title: 'La section a été supprimée.',
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          } catch (error) {
            console.error('Erreur lors de la suppression de la section :', error);
            // Swal.fire(
            //   'Erreur!',
            //   'Une erreur est survenue lors de la suppression.',
            //   'error'
            // );
            this.$swal({
              title: 'Erreur!',
              text: ' Une erreur est survenue lors de la suppression.',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      });
    },
    async updateSectionOrder(newOrder) {
      try {
        await updateSectionOrder(newOrder);


        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ordre des sections mis à jour avec succès',
            icon: 'EditIcon',
            variant: 'success',
          },
        });
      } catch (error) {
        console.error('Erreur lors de la mise à jour de l\'ordre des sections :', error);
        this.errorNotif('Erreur lors de la mise à jour de l\'ordre des sections')

      }
    }

  },

  computed:{
    statusVariant() {
        return (status) => (status ? "light-primary" : "light-danger");
      },
  },

  mounted() {
    this.fetchSections();
    sortable.create(document.getElementById('sortableTable').getElementsByTagName('tbody')[0], {
      animation: 150,
      ghostClass: 'sortable-ghost',
      onEnd: (event) => {
        const movedSection = this.sections.splice(event.oldIndex, 1)[0];
        this.sections.splice(event.newIndex, 0, movedSection);

        const newOrder = this.sections.map((section, index) => ({
          id: section.idPublic,
          position: index + 1,
        }));
        this.updateSectionOrder(newOrder);
      }
    });
  }
};
</script>

<style>
/* Styles CSS facultatifs */
.swal2-spacing-buttons .swal2-styled {
  margin: 5px;
  padding: 5px;
}
</style>
